import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {Icon, Popover, PopoverInteractionKind, Position, Menu, MenuItem} from "@blueprintjs/core";
import { List } from "immutable";
import numeral from "numeral";

// Components
import VirtualizedTable from "../../../components/common/virtualized-table";

// Actions
import { getReceipts, cleanReceipts } from "../../../actions/receipts";

// Numeral configuration
import 'numeral/locales/es-es'
numeral.locale('es-es');
numeral.defaultFormat('0,0.00 $');

class SupplierReceipts extends Component {
    constructor(props) {
        super(props);

        this.state = {};
    }
    componentDidMount() {
        this.props.getReceipts({
            filters: {
                supplier: this.props.supplierId
            },
            projection: 'receipt_code delivery_date supplier statistics.subtotal statistics.vat statistics.total',
            populateRefs: [{
                field: 'supplier',
                projection: 'basic_info.name'
            }],
            calculateStatistics: 'receipts'
        });
    }
    componentWillUnmount() {
        this.props.cleanReceipts();
    }

    getReceipt = (receiptId) => {
        const { receipts } = this.props;
        const index = receipts.findIndex( receipt => receipt.get('_id') === receiptId );

        return receipts.get(index);
    };

    render() {
        // Stats Zone
        let totalOrders = 0;

        this.props.receipts.forEach(order => totalOrders = totalOrders + order.getIn(['statistics', 'total']));

        // Receipts Table
        let tableData = this.props.receipts;
        let tableSettings = {
            showFooter: true,
            sortable: true,
            filterable: true,
            defaultSortFields: [],
            defaultSortDirections: ['asc'],
            height: tableData.size < 17 ? tableData.size * 40 : 680,
            rowHeight: 40,
            strippedRows: false
        };
        let tableColumns = {
            receipt_code: {
                title: 'Código',
                columnType: 'function',
                dataField: ['_id', 'receipt_code'],
                width: 100,
                style: {},
                sortable: true,
                sortableIndex: 1,
                filterable: true,
                filterableIndex: 1,
                nodeContent: (value) => {
                    return <Link to={ '/compras/albaranes/' + value[0] }>{ value[1] }</Link>
                }
            },
            delivery_date: {
                title: "Fecha de entrega",
                columnType: 'date',
                dataField: 'delivery_date',
                width: 150,
                style: {},
                sortable: true,
                filterable: true,
                format: 'DD/MM/YYYY'
            },
            supplier: {
                title: "Proveedor",
                columnType: 'text',
                dataField: 'supplier',
                width: 300,
                style: {},
                sortable: true,
                filterable: true,
            },
            subtotal: {
                title: "Subtotal",
                columnType: 'number',
                dataField: 'statistics.subtotal',
                width: 150,
                style: {textAlign: 'right'},
                sortable: false,
                filterable: true,
                footer: { type: 'operation', value: 'sum' }
            },
            vat: {
                title: "IVA",
                columnType: 'number',
                dataField: 'statistics.vat',
                width: 150,
                style: {textAlign: 'right'},
                sortable: false,
                filterable: true,
                footer: { type: 'operation', value: 'sum' }
            },
            total: {
                title: "Total",
                columnType: 'number',
                dataField: 'statistics.total',
                width: 150,
                style: {textAlign: 'right'},
                sortable: false,
                filterable: true,
                footer: { type: 'operation', value: 'sum' }
            },
            actions: {
                title: '',
                columnType: 'function',
                dataField: ['_id'],
                width: 30,
                style: { alignItems: 'center', maxWidth: 30 },
                sortable: false,
                filterable: false,
                nodeContent: (value) => {
                    const popoverContent = (
                        <Menu>
                            <MenuItem icon="eye-open" text="Ver detalle" onClick={ () => this.props.history.push('/compras/albaranes/' + value)} />
                        </Menu>
                    );

                    return (
                        <div>
                            <Popover
                                content={popoverContent}
                                interactionKind={PopoverInteractionKind.CLICK}
                                position={Position.LEFT_BOTTOM}
                            >
                                <Icon
                                    className="icon-custom"
                                    title={false}
                                    icon={'more'}
                                    iconSize={18}
                                    color="#183650"
                                />
                            </Popover>
                        </div>
                    );
                }
            }
        };

        return (
            <div className="panel-body">
                <div className="row stats-zone" style={{ marginBottom: 20 }} >
                    <div className="col-auto">
                        <span className="label ">{ this.props.receipts.size || 0 }</span>
                        <span>Albaranes</span>
                    </div>
                    <div className="col-auto">
                        <span className="label ">{ numeral(totalOrders).format() }</span>
                        <span>Importe total Albaranes</span>
                    </div>
                    { this.props.status === 'active'
                        ? <div className="col-auto ml-auto">
                            <button
                                className="btn btn-primary"
                                onClick={ () => this.props.history.push('/compras/albaranes/nuevo', { supplierId: this.props.supplierId }) }
                            >
                                <Icon icon="insert"/>Albaran
                            </button>
                        </div>
                        : null
                    }
                </div>
                <div className="row">
                    <div className="col">
                        <div className="ibox">
                            <div className="ibox-content">
                                <VirtualizedTable
                                    tableSettings={tableSettings}
                                    tableColumns={tableColumns}
                                    tableData={tableData}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {

    // Reducers
    const receiptsReducer = state.receipts;

    // Receipts
    let receipts = receiptsReducer.get('payload') || List([]);

    if (!(receipts instanceof List)) {
        receipts = List([])
    }

    return {
        receipts
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getReceipts: (query) => dispatch(getReceipts(query)),
        cleanReceipts: () => dispatch(cleanReceipts())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SupplierReceipts);


// WEBPACK FOOTER //
// ./src/containers/purchases/suppliers/SupplierReceipts.js